import { render } from "./Logo.vue?vue&type=template&id=8a930fd2&ts=true"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__